module.exports = __webpack_public_path__ + "static/media/prism-landing-background.b088cbf5.png";